/* SANTOS — free gift with any order
   Keeps exactly one free duffel bag in the cart whenever it has another product,
   and removes it when the cart has nothing else. The price drop to $0 comes from
   the automatic discount "Free Santos duffel bag with any order". */
(function () {
  'use strict';
  var GIFT_VARIANT = 67806283563322;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var realFetch = window.fetch.bind(window);
  var busy = false;

  function isCartWrite(url) {
    url = String(url || '');
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function post(path, body) {
    return realFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function sync() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return realFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var others = 0, giftQty = 0, giftKey = null;
        cart.items.forEach(function (it) {
          if (it.variant_id === GIFT_VARIANT) { giftQty += it.quantity; giftKey = it.key; }
          else others += it.quantity;
        });
        if (others > 0 && giftQty === 0) return post('cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1 }] }).then(function () { return true; });
        if (others > 0 && giftQty > 1) return post('cart/change.js', { id: giftKey, quantity: 1 }).then(function () { return true; });
        if (others === 0 && giftQty > 0) return post('cart/change.js', { id: giftKey, quantity: 0 }).then(function () { return true; });
        return false;
      })
      .catch(function () { return false; })
      .then(function (changed) {
        busy = false;
        if (changed) {
          if (document.body && document.body.dataset.template === 'cart') { window.location.reload(); }
          else if (window.SantosCart) { window.SantosCart.refresh(); }
        }
        return changed;
      });
  }

  // Run after every cart change made by the theme
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = realFetch(input, init);
    if (isCartWrite(url)) {
      p.then(function () { setTimeout(sync, 0); }, function () {});
    }
    return p;
  };

  // And once on page load (covers carts built before this script, and the cart page)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
